import writeXlsxFile from 'write-excel-file'

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      writeXlsxFile
    }
  }
})
